module.exports = __webpack_public_path__ + "static/capture-fda35670dd0bd03be88001d4483c6a71.png";